import { cn } from '@zealot/ui/lib/utils';
import * as React from 'react';

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from './breadcrumb';

type SimpleBreadcrumbItem = {
  label: string;
  href?: string;
};

type SimpleBreadcrumbProps = {
  items: SimpleBreadcrumbItem[];
  separator?: React.ReactNode;
  className?: string;
};

const SimpleBreadcrumb = ({ items, separator, className }: SimpleBreadcrumbProps) => {
  if (items.length === 0) return null;

  return (
    <Breadcrumb className={cn(className)}>
      <BreadcrumbList>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <React.Fragment key={item.label}>
              {index > 0 && <BreadcrumbSeparator>{separator}</BreadcrumbSeparator>}
              <BreadcrumbItem>
                {isLast || !item.href ? (
                  <BreadcrumbPage>{item.label}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink href={item.href}>{item.label}</BreadcrumbLink>
                )}
              </BreadcrumbItem>
            </React.Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
};

export type { SimpleBreadcrumbItem, SimpleBreadcrumbProps };
export { SimpleBreadcrumb };
